/*
 * @Author       : 萝卜兄台
 * @Date         : 2023-03-01 13:34:23
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2023-04-11 13:55:37
 * @FilePath     : \vue3-ts-mm\src\main.ts
 * @Description  : 这是描述
 */

import { createApp } from "vue";
import "./style.less";
import Antd from "ant-design-vue";
import App from "./App.vue";
import store from "./store/index";
import router from "./router";

import "ant-design-vue/dist/antd.less";
import JsonViewer from "vue3-json-viewer";
import "vue3-json-viewer/dist/index.css";
import infiniteScroll from "vue3-infinite-scroll-better";
import { VueMasonryPlugin } from "vue-masonry";
import Tinymce from "@/components/tinymce/Tinymce.vue";
import * as Icons from "@ant-design/icons-vue";
import i18n from './locales';

// 创建vue实例
const app = createApp(App);

app.component("Tinymce", Tinymce);
// 注册图标组件
for (const i in Icons) {
  app.component(i, Icons[i]);
}
// 挂载pinia
app.use(Antd);
app.use(store);
app.use(router);
app.use(JsonViewer);
app.use(infiniteScroll);
app.use(VueMasonryPlugin);
app.use(i18n);
app.mount("#app");
